<div class="container-header">
  <div class="title text-center">
    <h2>
      <strong>Previsão do Tempo</strong>
    </h2>
    <a href="{{data.url}}" target="_blank" class="text-muted">OpenWeatherMap.org</a>
  </div>

  <br><br>
</div>
<div class="m-t-sm">
  <div class="alert alert-danger" ng-if="data === 'error'">
    Não foi possível carregar a previsão do tempo no momento.
  </div>
  <p class="day-label" ng-repeat-start="item in data.list" ng-if="wf.isDifferentDate(item, $index)">
    {{wf.textDayLabel(item)}}
  </p>
  <div class="panel panel-default-agro1 weather-forecast-card" disabled ng-repeat-end>
    <div class="panel-heading">
      <h4 class="panel-title">
        {{item.weather[0].description | capitalize}}
        <span class="pull-right">
          <i class="fa fa-clock-o m-r-sm"></i>
          {{wf.textCardTime(item)}}
        </span>
      </h4>
    </div>
    <div class="panel-body">
      <i ng-class="wf.iconClass(item.weather[0].icon)" class="fa-5x"></i>
      <div class="pull-right text-right">
        <b class="temp m-b-xs">
          {{item.main.temp | number: 0}}
          <sup>&deg;C</sup>
        </b>
        <small ng-if="item.rain['3h']" class="text-muted">
          Chuva: {{wf.textRain(item) | number: 1}}mm
        </small>
      </div>
    </div>
  </div>
</div>
